if(!customElements.get('pdp-cross-sell')) {
  class ComponentPdpCrossSell extends HTMLElement {
    constructor() {
      super();
      this.atc = this.querySelector('.cross-atc');

      this.addEventListener('click',()=>{
        var data = new FormData();
        data.append('items[0][id]', this.dataset.variantId);
        data.append('items[0][quantity]', 1);
        
        $s.showLoadingOverlay();

        $s.post({
          url: '/cart/add.js',
          data: data,
          success: function(){
            $s.addToCartSuccess();
          },
          error: function(response){
            $s.addToCartFail(response.description);
          }
        })
      })
    }
  }
  customElements.define('pdp-cross-sell', ComponentPdpCrossSell);
}